import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from './study-form.module.scss';

import {
  StyledSelect,
  InputNumber,
} from '~/lib/HooksFormFields';
import { useGetEstimatesList } from '~/hooks/estimates';
import PreviewField from '~/components/PreviewField';
import { IOption } from '~/types/options';

const StudyForm = ({ isPreview } : { isPreview: boolean }) => {
  const { control, watch, setValue } = useFormContext();
  const { data: list = { studies: [] } } = useGetEstimatesList();
  const phase = watch();
  const studyValue = watch('study');
  const studyCustomValue = watch('studyCustomValue');
  // État local pour savoir si "other" est sélectionné (indépendant de la valeur de study)
  const [isOtherSelected, setIsOtherSelected] = useState(false);

  // Initialiser isOtherSelected et studyCustomValue si la valeur actuelle est personnalisée
  useEffect(() => {
    if (list?.studies && studyValue !== null && studyValue !== undefined && studyValue !== 'other') {
      const isInList = list.studies.some((study: IOption) => study.value === studyValue);
      if (!isInList) {
        // C'est une valeur personnalisée
        setIsOtherSelected(true);
        if (!studyCustomValue) {
          setValue('studyCustomValue', studyValue);
          setValue('study', null);
        }
      }
    } else if (studyValue === 'other') {
      setIsOtherSelected(true);
    }
  }, [list?.studies, studyValue, studyCustomValue, setValue]);

  const handleStudyChange = (option: IOption) => {
    if (option.label === 'Autre') {
      setIsOtherSelected(true);
      setValue('study', null);
      // Nettoyer studyCustomValue si on vient de sélectionner "other"
      if (!studyCustomValue) {
        setValue('studyCustomValue', null);
      }
    } else {
      setIsOtherSelected(false);
      setValue('study', option.value);
      setValue('studyCustomValue', null);
    }
  };

  const handleCustomValueChange = (value: number | string) => {
    if (!isPreview && isOtherSelected) {
      // Mettre à jour study avec la valeur personnalisée pour l'envoi au backend
      setValue('study', Number(value));
    }
  };

  return (
    <div id="study" className={styles.study}>
      <h4>Frais d&apos;études</h4>
      <div className={styles.row}>
        <div className={`${styles.containerField}`}>
        {isPreview
          ? <PreviewField
              label="Frais d'études"
              value={
                isOtherSelected && studyCustomValue
                  ? `${studyCustomValue}€`
                  : list?.studies?.find((a:IOption) => a.value === phase?.study)?.label || '---'
              }
            />
          : <StyledSelect
            label="Frais d'études"
            name='study'
            control={control}
            options={list?.studies.concat({ value: null, label: 'Autre' }) || []}
            handleChange={handleStudyChange}
          />
        }
        </div>
        {isOtherSelected && (
          <div className={`${styles.containerField}`}>
            {isPreview
              ? <PreviewField
                  label='Valeur personnalisée'
                  value={studyCustomValue ? `${studyCustomValue}€` : '---'}
                />
              : <InputNumber
                  label='Valeur personnalisée'
                  name='studyCustomValue'
                  control={control}
                  placeholder='Entrez une valeur'
                  min='0'
                  allowFloat={true}
                  handleChange={handleCustomValueChange}
                />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default StudyForm;
